import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import Header from './Header';
import Footer from './Footer';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Helmet } from "react-helmet";
import BookingModal from "./BookModal";
import Tab from "./Tab";
import NotFound from './NotFound';

function PackageDetails () {


const [highlights, setHighlights] = useState([]);
 const [destination, setDestination] = useState([]);



  const [currency, setCurrency] = useState(localStorage.getItem("currency") || "inr");

  useEffect(() => {
    const updateCurrency = () => {
      setCurrency(localStorage.getItem("currency") || "inr");
    };

    window.addEventListener("currency-change", updateCurrency);
    return () => window.removeEventListener("currency-change", updateCurrency);
  }, []);

  const getPrice = (item) => {
    if (!item) return "";

    if (currency === "usd") return `$ ${item.price_usd}`;
    if (currency === "aed") return `AED ${item.price_aed}`;
    return `₹ ${item.price_inr}`;
  };



  const { slug } = useParams();
  const [details, setDetails] = useState(null);
const itenary_details = details?.itenary_details;

  const [loading, setLoading] = useState(true);
const [notFound, setNotFound] = useState(false);
const [inclusions, setInclusions] = useState([]);
const [exclusions, setExclusions] = useState([]);
let itinerary = [];

try {
  if (itenary_details) {
    itinerary = JSON.parse(itenary_details);
  }
} catch (err) {
  console.log("Invalid itinerary JSON", err);
}

const faqs_raw = details?.faqs;

let faqs = [];

try {
  if (faqs_raw && faqs_raw.startsWith("[")) {
    faqs = JSON.parse(faqs_raw);
  }
} catch (err) {
  console.log("Invalid FAQ JSON", err);
}

  const [formData, setFormData] = useState({
    full_name: "",
    email_address: "",
    total_persons: "",
    travel_date: "",
    tour_detail: "",
    saveInfo: false,
  });

  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
/* ===============================
     BULLET HTML PARSER (FINAL)
  =============================== */
const parseListFromHtml = (htmlString) => {
  if (!htmlString) return [];

  // 1️⃣ Decode unicode escaped HTML
  let decoded;
  try {
    decoded = JSON.parse(`"${htmlString}"`);
  } catch (e) {
    decoded = htmlString;
  }

  // 2️⃣ Parse decoded HTML
  const div = document.createElement("div");
  div.innerHTML = decoded;

  // 3️⃣ Extract <li> items
  return Array.from(div.querySelectorAll("li"))
    .map(li => li.textContent.replace(/\s+/g, " ").trim())
    .filter(Boolean);
};


useEffect(() => {
  if (!slug) return;

  setLoading(true);
  setNotFound(false);

  fetch(`https://planjourneysglobal.com/admin/api/cruise_detail/${slug}`)
    .then((res) => res.json())
    .then((data) => {
      if (
        data?.status === true &&
        data?.data &&
        Object.keys(data.data).length > 0
      ) {
        setDetails(data.data);
      } else {
        setDetails(null);
        setNotFound(true);
      }

      setLoading(false);
    })
    .catch((err) => {
      console.error("Activity API Error:", err);

      setDetails(null);
      setNotFound(true);

      setLoading(false);
    });
}, [slug]);



  useEffect(() => {
  if (!details?.highlights_of_tours) return;

  const parser = new DOMParser();
  const doc = parser.parseFromString(
    details.highlights_of_tours,
    "text/html"
  );

  const parsedHighlights = Array.from(
    doc.querySelectorAll("li")
  ).map(li => li.textContent.trim());

  setHighlights(parsedHighlights);
}, [details]);


 /* ===============================
     PARSE INCLUSION / EXCLUSION
  =============================== */
  useEffect(() => {
    if (!details) return;

    setInclusions(parseListFromHtml(details.inclusion));
    setExclusions(parseListFromHtml(details.exclusion));
  }, [details]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMsg("");
    setErrorMsg("");

    try {
      const response = await fetch(
        "https://planjourneysglobal.com/admin/api/booking",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
          mode: "cors",

        }
      );

      const result = await response.json();

      if (response.ok) {
        setSuccessMsg("Your enquiry has been submitted successfully!");

        // Reset form
        setFormData({
          full_name: "",
          email_address: "",
          total_persons: "",
          travel_date: "",
          tour_detail: "",
          saveInfo: false,
        });

        setTimeout(() => {
          const modalEl = document.getElementById("enquiryModal");
          const modal = window.bootstrap.Modal.getInstance(modalEl);
          if (modal) modal.hide();
          setSuccessMsg("");
        }, 10000);
      } else {
        setErrorMsg(result.message || "Something went wrong!");
      }
    } catch (error) {
      setErrorMsg("Network error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
   useEffect(() => {
      fetch("https://planjourneysglobal.com/admin/api/popular_cruise")
        .then((res) => res.json())
        .then((data) => {
          setDestination(data?.data || []); 
        })
        .catch((err) => console.log("API Error:", err));
    }, []);


useEffect(() => {
  if (!details?.location_id || !details?.id) return;

  fetch(
    `https://planjourneysglobal.com/admin/api/related_packages/${details.location_id}/${details.id}`
  )
    .then((res) => res.json())
    .then((data) => {
      setDestination(data?.data || []);
    })
    .catch((err) => console.error("Relevant API Error:", err));
}, [details]);



const cabinList = Array.isArray(details?.cabin)
  ? details.cabin
  : details?.cabin
  ? details.cabin.replace(/[\[\]"]/g, "").split(/\n|,/)
  : [];


   if (loading) return <p></p>;

if (notFound) return <NotFound />;
    return(
<>
<style>
  {`
    .Persons{
    display:none;
    }
  `}
</style>
  <Helmet>
      {/* <title>{details.meta_title}</title>
      <meta name="description" content={details.meta_description} /> */}
      {details.meta_keyword && <meta name="keywords" content={details.meta_keyword} />}
      {/* {details.slug && <link rel="canonical" href={details.slug} />} */}

      {/* Open Graph */}
      {/* <meta property="og:title" content={details.meta_title} />
      <meta property="og:description" content={details.meta_description} />
        {details.image && (
          <meta
            property="og:image"
            content={`https://planjourneysglobal.com/admin/${details.image}`}
          />
        )}      
         {details.image && (
      <meta name="twitter:image"
        content={`https://planjourneysglobal.com/admin/${details.image}`}
      />
    )}
        {details.slug && <meta property="og:url" content={details.slug} />}
      <meta property="og:type" content="website" />

   
      <meta name="twitter:title" content={details.meta_title} />
      <meta name="twitter:description" content={details.meta_description} />
         
      <meta name="twitter:card" content="summary_large_image" /> */}
    </Helmet>
 <Header/>


<div
  className="breadcrumb-section"
  style={{
    backgroundImage: details?.image_top
      ? `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), 
         url("https://planjourneysglobal.com/admin/${details.image_top}")`
      : "none",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="container">
    <div className="banner-content">
      <h1 dangerouslySetInnerHTML={{ __html: details?.title }} />
    </div>
  </div>
</div>



  <div className="package-details-breadcrumb-bottom">
    <div className="container">
      <div className="details-breadcrumb-bottom-wrapper">
        <div className="left-content">
          <ul>
            <li>
              <svg
                width={12}
                height={12}
                viewBox="0 0 12 12"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M11.544 3.68665L4.87161 10.3626C4.76529 10.4653 4.63053 10.5186 4.49589 10.5186C4.42605 10.5187 4.35687 10.505 4.29236 10.4782C4.22785 10.4514 4.16929 10.4122 4.12005 10.3626L0.457651 6.70021C0.248491 6.49453 0.248491 6.15781 0.457651 5.94865L1.75173 4.65097C1.95033 4.45249 2.30481 4.45249 2.50341 4.65097L4.49589 6.64346L9.49833 1.63741C9.54761 1.58803 9.60613 1.54883 9.67055 1.52206C9.73498 1.49529 9.80405 1.48148 9.87381 1.48141C10.0155 1.48141 10.1503 1.53817 10.2495 1.63741L11.5436 2.93521C11.7531 3.14437 11.7531 3.48109 11.544 3.68665Z" />
              </svg>
              No Booking Fee
            </li>
            <li>
              <svg
                width={12}
                height={12}
                viewBox="0 0 12 12"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M11.544 3.68665L4.87161 10.3626C4.76529 10.4653 4.63053 10.5186 4.49589 10.5186C4.42605 10.5187 4.35687 10.505 4.29236 10.4782C4.22785 10.4514 4.16929 10.4122 4.12005 10.3626L0.457651 6.70021C0.248491 6.49453 0.248491 6.15781 0.457651 5.94865L1.75173 4.65097C1.95033 4.45249 2.30481 4.45249 2.50341 4.65097L4.49589 6.64346L9.49833 1.63741C9.54761 1.58803 9.60613 1.54883 9.67055 1.52206C9.73498 1.49529 9.80405 1.48148 9.87381 1.48141C10.0155 1.48141 10.1503 1.53817 10.2495 1.63741L11.5436 2.93521C11.7531 3.14437 11.7531 3.48109 11.544 3.68665Z" />
              </svg>
              Best Price Ever
            </li>
          </ul>
         
        </div>
        <div className="right-content">
          {/* <span>
            <img src="/assets/img/innerpages/icon/carbon-icon.svg" alt="" />
            100% Carbon Neutral
          </span>
          <div className="share-btn">
            <div className="share-icon">
              <svg
                width={14}
                height={14}
                viewBox="0 0 14 14"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g>
                  <path d="M11.1016 9.07812C10.2911 9.07812 9.57685 9.47682 9.12825 10.0831L5.24973 8.09714C5.31412 7.87765 5.35938 7.65018 5.35938 7.41016C5.35938 7.0846 5.29263 6.7751 5.17732 6.49042L9.23636 4.04786C9.68808 4.578 10.352 4.92188 11.1016 4.92188C12.4586 4.92188 13.5625 3.81798 13.5625 2.46094C13.5625 1.10389 12.4586 0 11.1016 0C9.74452 0 8.64062 1.10389 8.64062 2.46094C8.64062 2.77367 8.70502 3.07032 8.81185 3.34573L4.74072 5.79545C4.28939 5.28106 3.635 4.94922 2.89844 4.94922C1.54139 4.94922 0.4375 6.05311 0.4375 7.41016C0.4375 8.7672 1.54139 9.87109 2.89844 9.87109C3.7223 9.87109 4.44858 9.46069 4.89549 8.83734L8.76124 10.8169C8.69004 11.0467 8.64062 11.2861 8.64062 11.5391C8.64062 12.8961 9.74452 14 11.1016 14C12.4586 14 13.5625 12.8961 13.5625 11.5391C13.5625 10.182 12.4586 9.07812 11.1016 9.07812Z" />
                </g>
              </svg>
            </div>
            <ul className="social-list">
              <li>
                <a href="https://www.facebook.com/">
                  <i className="bx bxl-facebook" />
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/">
                  <i className="bx bxl-linkedin" />
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/">
                  <i className="bx bxl-youtube" />
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/">
                  <i className="bx bxl-instagram-alt" />
                </a>
              </li>
            </ul>
          </div> */}
        </div>
      </div>
    </div>
  </div>
  {/* Breadcrumb section End*/}

  {/* Enquiry Modal section Start*/}
  <div
      className="modal enquiry-modal fade"
      id="enquiryModal"
      tabIndex="-1"
      aria-labelledby="enquiryModalLabel"
      aria-hidden="true"
      data-bs-backdrop={loading ? "static" : "true"}
      data-bs-keyboard={loading ? "false" : "true"}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          {/* Close button */}
          <button
            type="button"
            className="close-btn"
            data-bs-dismiss="modal"
            aria-label="Close"
            disabled={loading}><svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.00247 0.500545C1.79016 0.505525 1.58918 0.582706 1.4362 0.735547L0.694403 1.479C0.345704 1.82743 0.389689 2.43243 0.79164 2.83493L3.00694 5.05341L0.79164 7.27092C0.389689 7.67328 0.345566 8.27842 0.694403 8.62753L1.4362 9.37044C1.7849 9.71872 2.38879 9.67543 2.7913 9.27293L5.00659 7.05473L7.22189 9.27293C7.62467 9.67543 8.22898 9.71872 8.57699 9.37044L9.31989 8.62753C9.6679 8.27856 9.62461 7.67342 9.22182 7.27092L7.00653 5.05341L9.22182 2.83493C9.62461 2.43243 9.6679 1.82743 9.31989 1.479L8.57699 0.735547C8.22898 0.386433 7.62467 0.430557 7.22189 0.833614L5.00659 3.05126L2.7913 0.833753C2.56515 0.606635 2.27482 0.493906 2.00247 0.500545Z"></path>
                    </svg></button> 

          <div className="modal-body">
            <h4 className="modal-title" id="enquiryModalLabel">
              We’d Love to Hear From You!
            </h4>

            <form className="enquiry-form-wrapper" onSubmit={handleSubmit}>
              <div className="row g-4 mb-50">
                <div className="col-md-6">
                  <div className="form-inner">
                    <label>Full Name</label>
                    <input
                      type="text"
                      name="full_name"
                      placeholder="Your Name"
                      value={formData.full_name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-inner">
                    <label>Email Address</label>
                    <input
                      type="email"
                      name="email_address"
                      placeholder="Email Address"
                      value={formData.email_address}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-inner">
                    <label>Number of People*</label>
                    <input
                      type="text"
                      name="total_persons"
                      placeholder="Number of people"
                      value={formData.total_persons}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-inner">
                    <label>Travel Date</label>
                    <input
                      type="date"
                      name="travel_date"
                      value={formData.travel_date}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="form-inner">
                    <label>Tour Details</label>
                    <textarea
                      name="tour_detail"
                      placeholder="Write about tour info"
                      value={formData.tour_detail}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="form-inner">
                <button
                  type="submit"
                  className="primary-btn1 black-bg"
                  disabled={loading} // prevent multiple clicks
                >
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </div>

              {successMsg && (
                <p className="text-success mt-2">{successMsg}</p>
              )}
              {errorMsg && <p className="text-danger mt-2">{errorMsg}</p>}
            </form>
          </div>
        </div>
      </div>
    </div>
  {/* Enquiry Modal section End*/}

 {/* Package Details Page Start*/}
<div className="package-details-page pt-100">
        <div className="container">
          <div className="row g-lg-4 gy-5 justify-content-between">
            {/* Left side */}
            <div className="col-xl-8 col-lg-8">
              <div className="package-details-warpper">
                <div className="package-info-wrap mb-0">
                  <h4 dangerouslySetInnerHTML={{ __html: details.title }}></h4>
                  <p dangerouslySetInnerHTML={{ __html: details.description }} />


<div className="cabin">
  {cabinList.length > 0 && (
    <div className="highlights-tour-area mb-60">
      <h4>Cabin</h4>

      <ul className="items-list">
        {cabinList.map((item, index) => (
          <li key={index}>{item.trim()}</li>
        ))}
      </ul>
    </div>
  )}
</div>



                  <ul className="package-info-list d-none">
                    <li> <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
                                        <g>
                                            <path
                                                d="M8.49943 13.5002H4.99992C4.86733 13.5002 4.74018 13.5529 4.64642 13.6467C4.55267 13.7404 4.5 13.8676 4.5 14.0002V18.9994C4.5 19.132 4.55267 19.2592 4.64642 19.3529C4.74018 19.4467 4.86733 19.4993 4.99992 19.4993H8.49943C8.63202 19.4993 8.75918 19.4467 8.85293 19.3529C8.94669 19.2592 8.99936 19.132 8.99936 18.9994V14.0002C8.99936 13.8676 8.94669 13.7404 8.85293 13.6467C8.75918 13.5529 8.63202 13.5002 8.49943 13.5002ZM7.99951 18.4995H5.49984V14.5001H7.99951V18.4995ZM16.9982 13.5002H13.4987C13.3661 13.5002 13.2389 13.5529 13.1452 13.6467C13.0514 13.7404 12.9987 13.8676 12.9987 14.0002V18.9994C12.9987 19.132 13.0514 19.2592 13.1452 19.3529C13.2389 19.4467 13.3661 19.4993 13.4987 19.4993H16.9982C17.1308 19.4993 17.2579 19.4467 17.3517 19.3529C17.4454 19.2592 17.4981 19.132 17.4981 18.9994V14.0002C17.4981 13.8676 17.4454 13.7404 17.3517 13.6467C17.2579 13.5529 17.1308 13.5002 16.9982 13.5002ZM16.4982 18.4995H13.9986V14.5001H16.4982V18.4995ZM16.9982 21.499H13.4987C13.3661 21.499 13.2389 21.5517 13.1452 21.6455C13.0514 21.7392 12.9987 21.8664 12.9987 21.999V26.9982C12.9987 27.1308 13.0514 27.258 13.1452 27.3517C13.2389 27.4455 13.3661 27.4982 13.4987 27.4982H16.9982C17.1308 27.4982 17.2579 27.4455 17.3517 27.3517C17.4454 27.258 17.4981 27.1308 17.4981 26.9982V21.999C17.4981 21.8664 17.4454 21.7392 17.3516 21.6455C17.2579 21.5517 17.1307 21.4991 16.9982 21.499ZM16.4982 26.4983H13.9986V22.4989H16.4982V26.4983ZM24.997 13.5002H21.4975C21.3649 13.5002 21.2378 13.5529 21.144 13.6467C21.0503 13.7404 20.9976 13.8676 20.9976 14.0002V18.9994C20.9976 19.132 21.0503 19.2592 21.144 19.3529C21.2378 19.4467 21.3649 19.4993 21.4975 19.4993H24.997C25.1296 19.4993 25.2568 19.4467 25.3505 19.3529C25.4443 19.2592 25.497 19.132 25.497 18.9994V14.0002C25.497 13.8676 25.4443 13.7404 25.3505 13.6467C25.2568 13.5529 25.1296 13.5002 24.997 13.5002ZM24.4971 18.4995H21.9975V14.5001H24.4971V18.4995ZM8.49943 21.499H4.99992C4.86733 21.499 4.74018 21.5517 4.64642 21.6455C4.55267 21.7392 4.5 21.8664 4.5 21.999V26.9982C4.5 27.1308 4.55267 27.258 4.64642 27.3517C4.74018 27.4455 4.86733 27.4982 4.99992 27.4982H8.49943C8.63202 27.4982 8.75918 27.4455 8.85293 27.3517C8.94669 27.258 8.99936 27.1308 8.99936 26.9982V21.999C8.99934 21.8664 8.94666 21.7392 8.85291 21.6455C8.75916 21.5517 8.63202 21.4991 8.49943 21.499ZM7.99951 26.4983H5.49984V22.4989H7.99951V26.4983ZM24.997 21.499H21.4975C21.3649 21.499 21.2378 21.5517 21.144 21.6455C21.0503 21.7392 20.9976 21.8664 20.9976 21.999V26.9982C20.9976 27.1308 21.0503 27.258 21.144 27.3517C21.2378 27.4455 21.3649 27.4982 21.4975 27.4982H24.997C25.1296 27.4982 25.2568 27.4455 25.3505 27.3517C25.4443 27.258 25.497 27.1308 25.497 26.9982V21.999C25.4969 21.8664 25.4443 21.7392 25.3505 21.6455C25.2568 21.5517 25.1296 21.4991 24.997 21.499ZM24.4971 26.4983H21.9975V22.4989H24.4971V26.4983Z" />
                                            <path
                                                d="M27.996 28.998V12.0004H28.4959C28.6285 12.0004 28.7556 11.9477 28.8494 11.854C28.9431 11.7602 28.9958 11.6331 28.9958 11.5005V9.00088C28.9958 8.93523 28.9829 8.87022 28.9578 8.80957C28.9326 8.74891 28.8958 8.6938 28.8494 8.64738C28.803 8.60096 28.7479 8.56413 28.6872 8.53901C28.6266 8.51389 28.5615 8.50096 28.4959 8.50096H27.996V6.50127C27.996 6.36868 27.9433 6.24152 27.8496 6.14777C27.7558 6.05402 27.6286 6.00135 27.4961 6.00135H26.4962V0.502089C26.4962 0.369501 26.4435 0.242344 26.3498 0.14859C26.256 0.0548369 26.1289 0.00216675 25.9963 0.00216675H3.99943C3.86685 0.00216675 3.73969 0.0548369 3.64594 0.14859C3.55218 0.242344 3.49951 0.369501 3.49951 0.502089V6.00129H2.49967C2.36708 6.00129 2.23992 6.05396 2.14617 6.14771C2.05242 6.24147 1.99975 6.36862 1.99975 6.50121V8.5009H1.49982C1.36724 8.5009 1.24008 8.55357 1.14633 8.64732C1.05257 8.74107 0.999902 8.86823 0.999902 9.00082V11.5004C0.999902 11.633 1.05257 11.7602 1.14633 11.8539C1.24008 11.9477 1.36724 12.0003 1.49982 12.0003H1.99975V28.9979H0V29.9977H30V28.9979H27.996V28.998ZM4.49936 1.00201H25.4963V6.00129H4.49936V1.00201ZM2.99959 7.00113H26.9961V8.5009H2.99959V7.00113ZM26.9961 28.998H2.99959V12.0004H26.9961V28.998H26.9961ZM2.49967 11.0006H1.99975V9.5008H27.996V11.0006H2.49967Z" />
                                            <path
                                                d="M14.2307 2.71242C14.1512 2.50922 14.0395 2.33373 13.8955 2.18601C13.7515 2.0383 13.5783 1.9224 13.3758 1.83844C13.1733 1.75447 12.9492 1.71246 12.7032 1.71246C12.4572 1.71246 12.2326 1.75406 12.0294 1.83732C11.8262 1.92058 11.6522 2.03642 11.5075 2.1849C11.3628 2.33338 11.2507 2.50922 11.1712 2.71248C11.0917 2.91568 11.052 3.13652 11.052 3.375C11.052 3.61347 11.0917 3.83431 11.1712 4.03752C11.2507 4.24072 11.3628 4.41656 11.5075 4.5651C11.6522 4.71357 11.8262 4.82941 12.0294 4.91267C12.2326 4.99594 12.4572 5.03754 12.7032 5.03754C12.9492 5.03754 13.1733 4.99594 13.3758 4.91267C13.5783 4.82947 13.7515 4.71357 13.8955 4.5651C14.0395 4.41662 14.1512 4.24078 14.2307 4.03752C14.3102 3.83431 14.35 3.61347 14.35 3.375C14.35 3.13646 14.3102 2.91562 14.2307 2.71242ZM13.6581 3.85523C13.6109 3.99697 13.543 4.11697 13.4545 4.21517C13.3661 4.31344 13.2584 4.38879 13.1317 4.44129C13.0049 4.49379 12.8621 4.52004 12.7031 4.52004C12.5442 4.52004 12.4009 4.49379 12.2735 4.44129C12.146 4.38879 12.0376 4.31344 11.9484 4.21517C11.8591 4.11691 11.7905 3.99697 11.7425 3.85523C11.6946 3.71349 11.6705 3.55342 11.6705 3.37494C11.6705 3.19646 11.6946 3.03639 11.7425 2.89465C11.7905 2.75291 11.8591 2.63256 11.9484 2.53359C12.0376 2.43463 12.146 2.35887 12.2735 2.30637C12.401 2.25387 12.5442 2.22762 12.7031 2.22762C12.8621 2.22762 13.0049 2.25387 13.1317 2.30637C13.2584 2.35887 13.366 2.43463 13.4545 2.53359C13.543 2.63256 13.6109 2.75291 13.6581 2.89465C13.7054 3.03639 13.729 3.19646 13.729 3.37494C13.729 3.55342 13.7054 3.71349 13.6581 3.85523ZM9.96305 1.74844V3.14771H8.43779V1.74844H7.82812V5.00144H8.43779V3.57967H9.96305V5.00144H10.5727V1.74844H9.96305ZM20.5096 4.50199V1.74844H19.9044V5.00144H21.8121V4.50199H20.5096ZM14.3769 1.74844V2.2456H15.3601V5.00144H15.9652V2.2456H16.9438V1.74844H14.3769ZM19.3802 2.22984V1.74844H17.3285V5.00144H19.3802V4.51775H17.9382V3.59765H19.0743V3.13195H17.9382V2.22984H19.3802Z" />
                                        </g>
                                    </svg>
                      <div className="content">
                        <span>Accommodation</span>
                        <strong>{details.accommodation ? JSON.parse(details.accommodation).join(", ") : ""}</strong>
                      </div>
                    </li>
                    <li> <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M15 7.5C13.5166 7.5 12.0666 7.93987 10.8332 8.76398C9.59986 9.58809 8.63856 10.7594 8.07091 12.1299C7.50325 13.5003 7.35472 15.0083 7.64411 16.4632C7.9335 17.918 8.64781 19.2544 9.6967 20.3033C10.7456 21.3522 12.082 22.0665 13.5368 22.3559C14.9917 22.6453 16.4997 22.4968 17.8701 21.9291C19.2406 21.3614 20.4119 20.4001 21.236 19.1668C22.0601 17.9334 22.5 16.4834 22.5 15C22.4977 13.0116 21.7068 11.1052 20.3008 9.6992C18.8948 8.29317 16.9884 7.50226 15 7.5ZM15 21.5625C13.7021 21.5625 12.4333 21.1776 11.3541 20.4565C10.2749 19.7354 9.43374 18.7105 8.93704 17.5114C8.44034 16.3122 8.31038 14.9927 8.5636 13.7197C8.81682 12.4467 9.44183 11.2774 10.3596 10.3596C11.2774 9.44183 12.4467 8.81681 13.7197 8.5636C14.9927 8.31038 16.3122 8.44034 17.5114 8.93704C18.7105 9.43374 19.7354 10.2749 20.4565 11.3541C21.1776 12.4333 21.5625 13.7021 21.5625 15C21.5605 16.7399 20.8685 18.4079 19.6382 19.6382C18.4079 20.8685 16.7399 21.5605 15 21.5625Z" />
                                        <path
                                            d="M28.5937 2.34375H27.6562C26.5377 2.34501 25.4654 2.78988 24.6745 3.58078C23.8836 4.37168 23.4387 5.444 23.4375 6.5625V7.55859C22.4473 6.43566 21.2428 5.52171 19.8948 4.87032C18.5468 4.21892 17.0823 3.84319 15.5872 3.76515C14.0921 3.68711 12.5964 3.90833 11.1879 4.41585C9.77944 4.92337 8.48642 5.70696 7.3847 6.7207L7.13398 2.78262C7.12506 2.65931 7.06779 2.54452 6.97464 2.46324C6.88149 2.38195 6.76 2.34076 6.63662 2.34863C6.51324 2.35649 6.39797 2.41278 6.3159 2.50524C6.23382 2.59769 6.1916 2.71883 6.19841 2.84227L6.49607 7.5174C6.28015 7.66934 5.66638 7.89756 4.68745 7.95504V2.8125C4.68745 2.68818 4.63807 2.56895 4.55016 2.48104C4.46225 2.39314 4.34302 2.34375 4.2187 2.34375C4.09438 2.34375 3.97515 2.39314 3.88725 2.48104C3.79934 2.56895 3.74995 2.68818 3.74995 2.8125V7.95498C2.82693 7.89979 2.18275 7.68961 1.9414 7.51594L2.239 2.84232C2.24581 2.71888 2.20358 2.59775 2.12151 2.50529C2.03944 2.41284 1.92416 2.35655 1.80078 2.34869C1.67741 2.34082 1.55592 2.38201 1.46277 2.4633C1.36962 2.54458 1.31235 2.65937 1.30343 2.78268L0.941262 8.4699C0.909135 9.01667 1.08368 9.55555 1.43029 9.97965C1.77689 10.4037 2.27023 10.6821 2.81245 10.7595V15.4688C2.68813 15.4688 2.5689 15.5181 2.481 15.606C2.39309 15.694 2.3437 15.8132 2.3437 15.9375V24.8438C2.3437 25.341 2.54125 25.8179 2.89288 26.1696C3.24451 26.5212 3.72142 26.7188 4.2187 26.7188C4.71598 26.7188 5.1929 26.5212 5.54453 26.1696C5.89616 25.8179 6.0937 25.341 6.0937 24.8438V21.8718C7.28797 23.4181 8.86423 24.6269 10.6674 25.3793C12.4706 26.1316 14.4385 26.4016 16.3777 26.1627C18.3168 25.9237 20.1604 25.1841 21.727 24.0165C23.2936 22.849 24.5293 21.2937 25.3125 19.5037V24.8438C25.3125 25.341 25.51 25.8179 25.8616 26.1696C26.2133 26.5212 26.6902 26.7188 27.1875 26.7188C27.6847 26.7188 28.1616 26.5212 28.5133 26.1696C28.8649 25.8179 29.0625 25.341 29.0625 24.8438V2.8125C29.0625 2.68818 29.0131 2.56895 28.9252 2.48104C28.8373 2.39314 28.718 2.34375 28.5937 2.34375ZM5.1562 24.8438C5.1562 25.0924 5.05743 25.3308 4.88162 25.5067C4.7058 25.6825 4.46734 25.7812 4.2187 25.7812C3.97006 25.7812 3.73161 25.6825 3.55579 25.5067C3.37998 25.3308 3.2812 25.0924 3.2812 24.8438V16.4062H5.1562V24.8438ZM3.74995 15.4688V10.7812H4.68745V15.4688H3.74995ZM5.31669 9.84375H3.12071C2.95143 9.84376 2.78391 9.80926 2.6284 9.74236C2.47289 9.67546 2.33266 9.57755 2.21626 9.45463C2.09986 9.3317 2.00974 9.18634 1.95141 9.02742C1.89308 8.8685 1.86777 8.69935 1.877 8.53031C2.40259 8.74652 3.17573 8.90625 4.2187 8.90625C5.07529 8.90625 5.9355 8.78643 6.56029 8.53254C6.56926 8.7014 6.54375 8.87031 6.4853 9.02899C6.42686 9.18766 6.3367 9.33277 6.22034 9.45546C6.10398 9.57815 5.96384 9.67586 5.80848 9.74261C5.65312 9.80937 5.48579 9.84378 5.31669 9.84375ZM21.989 22.5831C20.855 23.6282 19.501 24.4057 18.0267 24.8583C16.5525 25.3109 14.9955 25.4272 13.4703 25.1984C11.9452 24.9697 10.4908 24.4018 9.2142 23.5366C7.93757 22.6714 6.87124 21.531 6.0937 20.1991V15.9375C6.0937 15.8132 6.04432 15.694 5.95641 15.606C5.8685 15.5181 5.74927 15.4688 5.62495 15.4688V10.7595C6.16757 10.682 6.66122 10.4034 7.00785 9.97878C7.35448 9.55419 7.52872 9.01475 7.49597 8.46762L7.46368 7.96131C8.51072 6.84001 9.79479 5.96649 11.2223 5.40442C12.6497 4.84236 14.1846 4.60592 15.7151 4.71233C17.2455 4.81875 18.733 5.26534 20.0689 6.01956C21.4049 6.77377 22.5557 7.8166 23.4375 9.07201V15.9375C23.4375 16.0618 23.4868 16.181 23.5747 16.269C23.6627 16.3569 23.7819 16.4062 23.9062 16.4062H25.2169C24.8931 18.7783 23.7515 20.9629 21.989 22.5831ZM28.125 24.8438C28.125 25.0924 28.0262 25.3308 27.8504 25.5067C27.6746 25.6825 27.4361 25.7812 27.1875 25.7812C26.9388 25.7812 26.7004 25.6825 26.5245 25.5067C26.3487 25.3308 26.25 25.0924 26.25 24.8438V16.4062H28.125V24.8438ZM28.125 15.4688H24.375V6.5625C24.3759 5.69256 24.7219 4.85853 25.3371 4.24339C25.9522 3.62824 26.7863 3.28223 27.6562 3.28125H28.125V15.4688Z" />
                                    </svg>
                      <div className="content">
                        <span>Meals</span>
                        <strong>{details.meals}</strong>
                      </div>
                    </li>
                    <li>  <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M19.6914 2.34375C19.368 2.34375 19.1055 2.60625 19.1055 2.92969C19.1055 3.25313 19.368 3.51562 19.6914 3.51562C20.0148 3.51562 20.2773 3.25313 20.2773 2.92969C20.2773 2.60625 20.0148 2.34375 19.6914 2.34375ZM10.3164 2.34375C9.99297 2.34375 9.73047 2.60625 9.73047 2.92969C9.73047 3.25313 9.99297 3.51562 10.3164 3.51562C10.6398 3.51562 10.9023 3.25313 10.9023 2.92969C10.9023 2.60625 10.6398 2.34375 10.3164 2.34375Z" />
                                        <path
                                            d="M27.1907 29.0089L23.3134 24.9582C24.8798 24.9021 26.137 23.6111 26.137 22.0312V4.64473C26.1361 3.69546 25.8069 2.77573 25.2052 2.04152C24.6038 1.30969 23.7613 0.805371 22.8333 0.621797C20.7491 0.208741 18.6295 0.000483935 16.5048 0L13.4093 0C11.3137 0.000427757 9.22333 0.207365 7.16836 0.617812C5.25791 1.00002 3.87135 2.69168 3.87135 4.64004V22.0312C3.87135 23.6244 5.14986 24.9237 6.73465 24.9592L2.81361 29.0064C2.7335 29.089 2.67952 29.1934 2.65839 29.3066C2.63726 29.4197 2.64994 29.5366 2.69483 29.6426C2.73972 29.7486 2.81483 29.839 2.9108 29.9026C3.00677 29.9661 3.11933 30 3.23443 30H7.42389C7.51649 30 7.60777 29.9781 7.69025 29.936C7.77272 29.8939 7.84405 29.8328 7.89838 29.7578L9.67576 27.3047H20.3847L22.1621 29.7579C22.2164 29.8329 22.2878 29.8939 22.3702 29.936C22.4527 29.978 22.544 30 22.6366 30H26.7674C26.8822 30 26.9945 29.9663 27.0903 29.903C27.1861 29.8397 27.2612 29.7497 27.3063 29.6442C27.3513 29.5386 27.3644 29.4221 27.3439 29.3092C27.3233 29.1962 27.27 29.0918 27.1907 29.0089ZM5.04322 22.0312V4.64004C5.04322 3.24826 6.03363 2.03994 7.39811 1.76689C9.37741 1.37164 11.3908 1.17233 13.4092 1.17188H16.5047C18.5481 1.17188 20.6005 1.3735 22.6054 1.77123C23.2702 1.90356 23.8688 2.26184 24.2995 2.78525C24.7292 3.30969 24.9644 3.96663 24.965 4.64467V22.0312C24.965 23.0005 24.1765 23.7891 23.2072 23.7891H6.80098C5.83178 23.7891 5.04322 23.0005 5.04322 22.0312ZM7.12488 28.8281H4.61795L8.36461 24.9609H9.92684L7.12488 28.8281ZM10.5248 26.1328L11.3739 24.9609H18.6866L19.5356 26.1328H10.5248ZM22.9356 28.8281L20.1337 24.9609H21.6938L25.3955 28.8281H22.9356Z" />
                                        <path
                                            d="M23.207 4.6875H6.80078C6.47723 4.6875 6.21484 4.94988 6.21484 5.27344V15C6.21484 15.3236 6.47723 15.5859 6.80078 15.5859H23.207C23.5306 15.5859 23.793 15.3236 23.793 15V5.27344C23.793 4.94988 23.5306 4.6875 23.207 4.6875ZM14.418 14.4141H7.38672V5.85938H14.418V14.4141ZM22.6211 14.4141H15.5898V5.85938H22.6211V14.4141ZM17.3477 2.34375H12.6602C12.3366 2.34375 12.0742 2.60613 12.0742 2.92969C12.0742 3.25324 12.3366 3.51562 12.6602 3.51562H17.3477C17.6712 3.51562 17.9336 3.25324 17.9336 2.92969C17.9336 2.60613 17.6712 2.34375 17.3477 2.34375ZM21.4492 17.3438C20.1569 17.3438 19.1055 18.3952 19.1055 19.6875C19.1055 20.9798 20.1569 22.0312 21.4492 22.0312C22.7416 22.0312 23.793 20.9798 23.793 19.6875C23.793 18.3952 22.7416 17.3438 21.4492 17.3438ZM21.4492 20.8594C20.803 20.8594 20.2773 20.3337 20.2773 19.6875C20.2773 19.0413 20.803 18.5156 21.4492 18.5156C22.0954 18.5156 22.6211 19.0413 22.6211 19.6875C22.6211 20.3337 22.0954 20.8594 21.4492 20.8594ZM8.55859 17.3438C7.26625 17.3438 6.21484 18.3952 6.21484 19.6875C6.21484 20.9798 7.26631 22.0312 8.55859 22.0312C9.85094 22.0312 10.9023 20.9798 10.9023 19.6875C10.9023 18.3952 9.85094 17.3438 8.55859 17.3438ZM8.55859 20.8594C7.91242 20.8594 7.38672 20.3337 7.38672 19.6875C7.38672 19.0413 7.91242 18.5156 8.55859 18.5156C9.20477 18.5156 9.73047 19.0413 9.73047 19.6875C9.73047 20.3337 9.20477 20.8594 8.55859 20.8594ZM17.3477 17.9297H12.6602C12.3366 17.9297 12.0742 18.1921 12.0742 18.5156C12.0742 18.8392 12.3366 19.1016 12.6602 19.1016H17.3477C17.6712 19.1016 17.9336 18.8392 17.9336 18.5156C17.9336 18.1921 17.6713 17.9297 17.3477 17.9297ZM17.3477 20.2734H12.6602C12.3366 20.2734 12.0742 20.5358 12.0742 20.8594C12.0742 21.1829 12.3366 21.4453 12.6602 21.4453H17.3477C17.6712 21.4453 17.9336 21.1829 17.9336 20.8594C17.9336 20.5358 17.6713 20.2734 17.3477 20.2734Z" />
                                    </svg>
                      <div className="content">
                        <span>Transportation</span>
                        <strong>{details.transportation}</strong>
                      </div>
                    </li>
                 
                    <li><svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M7.55227 10.4163C6.94457 10.4159 6.36185 10.1745 5.93203 9.74487C5.50221 9.31529 5.26043 8.7327 5.25977 8.12501C5.25977 6.86251 6.28852 5.83376 7.55227 5.83376C8.81477 5.83376 9.84352 6.86126 9.84352 8.12501C9.84352 9.38751 8.81602 10.4163 7.55227 10.4163ZM7.55227 6.97876C7.25752 6.99252 6.97941 7.1193 6.77569 7.33276C6.57197 7.54621 6.45831 7.82994 6.45831 8.12501C6.45831 8.42007 6.57197 8.7038 6.77569 8.91725C6.97941 9.13071 7.25752 9.25749 7.55227 9.27126C7.84701 9.25749 8.12512 9.13071 8.32884 8.91725C8.53256 8.7038 8.64622 8.42007 8.64622 8.12501C8.64622 7.82994 8.53256 7.54621 8.32884 7.33276C8.12512 7.1193 7.84701 6.99252 7.55227 6.97876ZM24.166 7.26501H12.7085C12.5567 7.26501 12.4111 7.20469 12.3037 7.09732C12.1963 6.98996 12.136 6.84434 12.136 6.69251C12.136 6.54067 12.1963 6.39505 12.3037 6.28769C12.4111 6.18032 12.5567 6.12001 12.7085 6.12001H24.166C24.3179 6.12001 24.4635 6.18032 24.5708 6.28769C24.6782 6.39505 24.7385 6.54067 24.7385 6.69251C24.7385 6.84434 24.6782 6.98996 24.5708 7.09732C24.4635 7.20469 24.3179 7.26501 24.166 7.26501ZM19.5835 10.13H12.7085C12.5567 10.13 12.4111 10.0697 12.3037 9.96232C12.1963 9.85496 12.136 9.70934 12.136 9.55751C12.136 9.40567 12.1963 9.26005 12.3037 9.15269C12.4111 9.04532 12.5567 8.98501 12.7085 8.98501H19.5835C19.7354 8.98501 19.881 9.04532 19.9883 9.15269C20.0957 9.26005 20.156 9.40567 20.156 9.55751C20.156 9.70934 20.0957 9.85496 19.9883 9.96232C19.881 10.0697 19.7354 10.13 19.5835 10.13ZM7.55227 17.2913C6.94457 17.2909 6.36185 17.0495 5.93203 16.6199C5.50221 16.1903 5.26043 15.6077 5.25977 15C5.25977 13.7375 6.28852 12.7088 7.55227 12.7088C8.81477 12.7088 9.84352 13.7363 9.84352 15C9.84352 16.2625 8.81602 17.2913 7.55227 17.2913ZM7.55227 13.8538C7.25752 13.8675 6.97941 13.9943 6.77569 14.2078C6.57197 14.4212 6.45831 14.7049 6.45831 15C6.45831 15.2951 6.57197 15.5788 6.77569 15.7923C6.97941 16.0057 7.25752 16.1325 7.55227 16.1463C7.84701 16.1325 8.12512 16.0057 8.32884 15.7923C8.53256 15.5788 8.64622 15.2951 8.64622 15C8.64622 14.7049 8.53256 14.4212 8.32884 14.2078C8.12512 13.9943 7.84701 13.8675 7.55227 13.8538ZM24.166 14.1413H12.7085C12.5565 14.1413 12.4107 14.0809 12.3033 13.9734C12.1958 13.8659 12.1354 13.7201 12.1354 13.5681C12.1354 13.4161 12.1958 13.2704 12.3033 13.1629C12.4107 13.0554 12.5565 12.995 12.7085 12.995H24.166C24.3179 12.995 24.4635 13.0553 24.5708 13.1627C24.6782 13.2701 24.7385 13.4157 24.7385 13.5675C24.7385 13.7193 24.6782 13.865 24.5708 13.9723C24.4635 14.0797 24.3179 14.1413 24.166 14.1413ZM19.5835 17.005H12.7085C12.5567 17.005 12.4111 16.9447 12.3037 16.8373C12.1963 16.73 12.136 16.5843 12.136 16.4325C12.136 16.2807 12.1963 16.1351 12.3037 16.0277C12.4111 15.9203 12.5567 15.86 12.7085 15.86H19.5835C19.7354 15.86 19.881 15.9203 19.9883 16.0277C20.0957 16.1351 20.156 16.2807 20.156 16.4325C20.156 16.5843 20.0957 16.73 19.9883 16.8373C19.881 16.9447 19.7354 17.005 19.5835 17.005ZM7.55227 24.1663C6.94457 24.1659 6.36185 23.9245 5.93203 23.4949C5.50221 23.0653 5.26043 22.4827 5.25977 21.875C5.25977 20.6125 6.28852 19.5838 7.55227 19.5838C8.81477 19.5838 9.84352 20.6113 9.84352 21.875C9.84352 23.1375 8.81602 24.1663 7.55227 24.1663ZM7.55227 20.7288C7.25752 20.7425 6.97941 20.8693 6.77569 21.0828C6.57197 21.2962 6.45831 21.5799 6.45831 21.875C6.45831 22.1701 6.57197 22.4538 6.77569 22.6673C6.97941 22.8807 7.25752 23.0075 7.55227 23.0213C7.84701 23.0075 8.12512 22.8807 8.32884 22.6673C8.53256 22.4538 8.64622 22.1701 8.64622 21.875C8.64622 21.5799 8.53256 21.2962 8.32884 21.0828C8.12512 20.8693 7.84701 20.7425 7.55227 20.7288ZM24.166 21.0163H12.7085C12.5565 21.0163 12.4107 20.9559 12.3033 20.8484C12.1958 20.7409 12.1354 20.5951 12.1354 20.4431C12.1354 20.2911 12.1958 20.1454 12.3033 20.0379C12.4107 19.9304 12.5565 19.87 12.7085 19.87H24.166C24.3179 19.87 24.4635 19.9303 24.5708 20.0377C24.6782 20.1451 24.7385 20.2907 24.7385 20.4425C24.7385 20.5943 24.6782 20.74 24.5708 20.8473C24.4635 20.9547 24.3179 21.0163 24.166 21.0163ZM19.5835 23.88H12.7085C12.5567 23.88 12.4111 23.8197 12.3037 23.7123C12.1963 23.605 12.136 23.4593 12.136 23.3075C12.136 23.1557 12.1963 23.0101 12.3037 22.9027C12.4111 22.7953 12.5567 22.735 12.7085 22.735H19.5835C19.7354 22.735 19.881 22.7953 19.9883 22.9027C20.0957 23.0101 20.156 23.1557 20.156 23.3075C20.156 23.4593 20.0957 23.605 19.9883 23.7123C19.881 23.8197 19.7354 23.88 19.5835 23.88Z" />
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M21.4162 2.39625H8.58375C7.28125 2.39625 6.3725 2.39625 5.66625 2.455C4.9725 2.51125 4.575 2.6175 4.2725 2.77C3.62556 3.09959 3.09959 3.62556 2.77 4.2725C2.61625 4.575 2.51125 4.9725 2.455 5.66625C2.39625 6.3725 2.39625 7.28125 2.39625 8.58375V21.4162C2.39625 22.7187 2.39625 23.6262 2.455 24.3337C2.51125 25.0275 2.6175 25.425 2.77 25.7275C3.09959 26.3744 3.62556 26.9004 4.2725 27.23C4.575 27.3837 4.9725 27.4887 5.66625 27.545C6.3725 27.6037 7.28125 27.6037 8.58375 27.6037H21.4162C22.7187 27.6037 23.6262 27.6037 24.3337 27.545C25.0275 27.4887 25.425 27.3825 25.7275 27.23C26.3744 26.9004 26.9004 26.3744 27.23 25.7275C27.3837 25.425 27.4887 25.0275 27.545 24.3337C27.6037 23.6262 27.6037 22.7187 27.6037 21.4162V8.58375C27.6037 7.28125 27.6037 6.3725 27.545 5.66625C27.4887 4.9725 27.3825 4.575 27.23 4.2725C26.9004 3.62556 26.3744 3.09959 25.7275 2.77C25.425 2.61625 25.0275 2.51125 24.3337 2.455C23.6262 2.39625 22.7187 2.39625 21.4162 2.39625ZM1.75 3.7525C1.25 4.7325 1.25 6.01625 1.25 8.58375V21.4162C1.25 23.9837 1.25 25.2662 1.75 26.2475C2.18875 27.11 2.89 27.81 3.7525 28.25C4.7325 28.75 6.01625 28.75 8.58375 28.75H21.4162C23.9837 28.75 25.2662 28.75 26.2475 28.25C27.1096 27.8105 27.8105 27.1096 28.25 26.2475C28.75 25.2675 28.75 23.9837 28.75 21.4162V8.58375C28.75 6.01625 28.75 4.73375 28.25 3.7525C27.8106 2.89036 27.1096 2.1894 26.2475 1.75C25.2675 1.25 23.9837 1.25 21.4162 1.25H8.58375C6.01625 1.25 4.73375 1.25 3.7525 1.75C2.89 2.18875 2.19 2.89 1.75 3.7525Z" />
                                    </svg>
                      <div className="content">
                        <span>Category</span>
                        <strong>{details.tour_type ? JSON.parse(details.tour_type).join(", ") : ""}</strong>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
               <Tab></Tab>
               <div className="package-details-warpper">
           {highlights?.length > 0 && (
            <div className="highlights-tour-area mb-60" id="Highlights">
              <h4>Highlights of the Tour</h4>
              <div className="highlights-wrap">
               <ul className="items-list">
                 {highlights.map((item, index) => (
                  <li key={index}>
                   <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15V16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16V15C11.866 15 15 11.866 15 8Z"></path>
                                            <path d="M11.6947 6.45795L7.24644 10.9086C7.17556 10.9771 7.08572 11.0126 6.99596 11.0126C6.9494 11.0127 6.90328 11.0035 6.86027 10.9857C6.81727 10.9678 6.77822 10.9416 6.7454 10.9086L4.3038 8.46699C4.16436 8.32987 4.16436 8.10539 4.3038 7.96595L5.16652 7.10083C5.29892 6.96851 5.53524 6.96851 5.66764 7.10083L6.99596 8.42915L10.3309 5.09179C10.3638 5.05887 10.4028 5.03274 10.4457 5.01489C10.4887 4.99705 10.5347 4.98784 10.5812 4.98779C10.6757 4.98779 10.7656 5.02563 10.8317 5.09179L11.6944 5.95699C11.8341 6.09643 11.8341 6.32091 11.6947 6.45795Z"></path>
                                        </svg>

                    {item}
                  </li>
                ))}
            </ul>

              </div>
            </div>
)}
    {itinerary?.length > 0 && (
  <>
    <div className="itinerary-title" id="Itinerary">
      <h4>Tour Itinerary</h4>
    </div>

    <div className="accordion" id="accordionTourPlan">
      {itinerary.map((item, index) => (
        <div className="accordion-item" key={index}>
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              data-bs-toggle="collapse"
              data-bs-target={`#day-${index}`}
            >
              <span
                dangerouslySetInnerHTML={{ __html: item.title }}
              />
            </button>
          </h2>

          <div
            id={`day-${index}`}
            className="accordion-collapse collapse"
            data-bs-parent="#accordionTourPlan"
          >
            <div
              className="accordion-body"
              dangerouslySetInnerHTML={{ __html: item.details }}
            />
          </div>
        </div>
      ))}
    </div>
  </>
)}



       {/* <div dangerouslySetInnerHTML={{ __html: details.day_details }}></div> */}
            </div>
            <div className="feature-list-area mb-60">
              <div className="itinerary-title mt-4">
                <h4>Package Features List</h4>
              </div>
              <div class="highlights-wrapssd" id="Inclusions">
              <div className="row gy-md-5 gy-4 justify-content-between highlights-wraps">

                <div className="col-lg-6 col-md-6">
                  <div className="single-feature-list">
                    <h6>Include Features</h6>
                  <ul className="items-list">
                  {inclusions.map((item, index) => (
                    <li key={index}>
                   <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15V16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16V15C11.866 15 15 11.866 15 8Z"></path>
                                            <path d="M11.6947 6.45795L7.24644 10.9086C7.17556 10.9771 7.08572 11.0126 6.99596 11.0126C6.9494 11.0127 6.90328 11.0035 6.86027 10.9857C6.81727 10.9678 6.77822 10.9416 6.7454 10.9086L4.3038 8.46699C4.16436 8.32987 4.16436 8.10539 4.3038 7.96595L5.16652 7.10083C5.29892 6.96851 5.53524 6.96851 5.66764 7.10083L6.99596 8.42915L10.3309 5.09179C10.3638 5.05887 10.4028 5.03274 10.4457 5.01489C10.4887 4.99705 10.5347 4.98784 10.5812 4.98779C10.6757 4.98779 10.7656 5.02563 10.8317 5.09179L11.6944 5.95699C11.8341 6.09643 11.8341 6.32091 11.6947 6.45795Z"></path>
                                        </svg>

                      {item}
                    </li>
                  ))}
</ul>

                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="single-feature-list">
                    <h6>Exclude Features</h6>
                  <ul className="items-list exclusion">
  {exclusions.map((item, index) => (
    <li key={index}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle opacity="0.5" cx="12" cy="12" r="10" stroke="#000000" stroke-width="1.5"></circle> <path d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5" stroke="#000000" stroke-width="1.5" stroke-linecap="round"></path> </g></svg>
    

      {item}
    </li>
  ))}
</ul>

                  </div>
                </div>
                </div>
              </div>
            </div>
              {destination?.length > 0 && (
             <div className="location-slider-wrap mb-60">
                          <h4>Relevant Packages </h4>
                          <div className="location-slider-area">
                            <div className="swiper package-dt-location-slider">
                              <Swiper className="swiper-wrapper"
                              modules={[Pagination]}
                              pagination={{ clickable: true }}
                              slidesPerView={3}
                              spaceBetween={10}
                              loop={true}
                            >
                       {destination.map((item) => (
                <SwiperSlide key={item.id} className="swiper-slide">
                  <div className="location-card">
                    <div className="destination-img">
                      <Link to={`/tour-package/${item.slug}`} className="location-img">
                        <img
                          src={
                            item.image
                              ? `https://planjourneysglobal.com/admin/${item.image}`
                              : "/assets/img/no-image.png"
                          }
                          alt={item.package_name || item.name}
                          onError={(e) => {
                            e.target.src = "/assets/img/no-image.png";
                          }}
                        />
                      </Link>
                    </div>
            
                    <div className="location-content">
                      <h6>
                        <Link to={`/tour-package/${item.slug}`}>
                          {item.title}
                        </Link>
                      </h6>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            
            
                               
                            </Swiper>
                            </div>
                           
                          </div>
                        </div>
                      )}
                                  <div className="tour-itinerary-area mb-60 ">
           

{faqs?.length > 0 && (
  <>
    <div className="itinerary-title mt-4" id="Faq">
      <h4>FAQ</h4>
    </div>

    <div className="accordion" id="faqAccordion">
      {faqs.map((item, index) => (
        <div className="accordion-item" key={index}>
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              data-bs-toggle="collapse"
              data-bs-target={`#faq-${index}`}
            >
              <div dangerouslySetInnerHTML={{ __html: item.question }}></div>
            </button>
          </h2>

          <div
            id={`faq-${index}`}
            className="accordion-collapse collapse"
            data-bs-parent="#faqAccordion"
          >
            <div className="accordion-body">
              <div
                dangerouslySetInnerHTML={{ __html: item.answer }}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  </>
)}
          </div>
            </div>

            {/* Right Sidebar */}
            <div className="col-lg-4">
              <div className="package-details-sidebar">
                <div className="pricing-and-booking-area mb-40">
                  {details.discount_percent && (
                    <div className="batch">
                      <span>{details.discount_percent}% Off</span>
                    </div>
                  )}
                 <h6 >Starting From</h6>
                  <div className="price-area">
                    <span>
                     <span>{getPrice(details)}</span>
                      <sub> / Person</sub>
                    </span>
                  </div>

                  <ul>
                  
                    <li>Your Safety is Our Top Priority.</li>
                  </ul>

               

                  <button
                    className="primary-btn1 transparent"
                    data-bs-toggle="modal"
                    data-bs-target="#enquiryModals"
                  >
                  <span>
                                    Book Now
                                    <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M9.73535 1.14746C9.57033 1.97255 9.32924 3.26406 9.24902 4.66797C9.16817 6.08312 9.25559 7.5453 9.70214 8.73633C9.84754 9.12406 9.65129 9.55659 9.26367 9.70215C8.9001 9.83849 8.4969 9.67455 8.32812 9.33398L8.29785 9.26367L8.19921 8.98438C7.73487 7.5758 7.67054 5.98959 7.75097 4.58203C7.77875 4.09598 7.82525 3.62422 7.87988 3.17969L1.53027 9.53027C1.23738 9.82317 0.762615 9.82317 0.469722 9.53027C0.176829 9.23738 0.176829 8.76262 0.469722 8.46973L6.83593 2.10254C6.3319 2.16472 5.79596 2.21841 5.25 2.24902C3.8302 2.32862 2.2474 2.26906 0.958003 1.79102L0.704097 1.68945L0.635738 1.65527C0.303274 1.47099 0.157578 1.06102 0.310542 0.704102C0.463655 0.347333 0.860941 0.170391 1.22363 0.28418L1.29589 0.310547L1.48828 0.387695C2.47399 0.751207 3.79966 0.827571 5.16601 0.750977C6.60111 0.670504 7.97842 0.428235 8.86132 0.262695L9.95312 0.0585938L9.73535 1.14746Z">
                                        </path>
                                    </svg>
                                </span>
                                <span>
 Book Now                                    <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M9.73535 1.14746C9.57033 1.97255 9.32924 3.26406 9.24902 4.66797C9.16817 6.08312 9.25559 7.5453 9.70214 8.73633C9.84754 9.12406 9.65129 9.55659 9.26367 9.70215C8.9001 9.83849 8.4969 9.67455 8.32812 9.33398L8.29785 9.26367L8.19921 8.98438C7.73487 7.5758 7.67054 5.98959 7.75097 4.58203C7.77875 4.09598 7.82525 3.62422 7.87988 3.17969L1.53027 9.53027C1.23738 9.82317 0.762615 9.82317 0.469722 9.53027C0.176829 9.23738 0.176829 8.76262 0.469722 8.46973L6.83593 2.10254C6.3319 2.16472 5.79596 2.21841 5.25 2.24902C3.8302 2.32862 2.2474 2.26906 0.958003 1.79102L0.704097 1.68945L0.635738 1.65527C0.303274 1.47099 0.157578 1.06102 0.310542 0.704102C0.463655 0.347333 0.860941 0.170391 1.22363 0.28418L1.29589 0.310547L1.48828 0.387695C2.47399 0.751207 3.79966 0.827571 5.16601 0.750977C6.60111 0.670504 7.97842 0.428235 8.86132 0.262695L9.95312 0.0585938L9.73535 1.14746Z">
                                        </path>
                                    </svg>
                                </span>
                  </button>

                  <span>  Bonus Activity Included – Limited Time!</span>
                </div>
              </div>
               
            </div>
          </div>
        </div>
      </div>

  {/* Package Details Page End*/}




  {/* Package Details Page Start*/}

  {/* Package Details Page End*/}




  <BookingModal
        // Pass the API data as props. 
        // Ensure the field names match your API response (e.g., details.package_name)
        packageName={details.package_name || ""} 
        packageId={details.id || ""} 
        defaultDestination={details.destination || ""}
        type="package" 
      />


  <Footer />
</>

    )
}
export default PackageDetails;